<template>
  <div class="extraPageComp generalbox">
    <div @click="$emit('close')" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2>{{modalTitle}}</h2>
    </div>
    <div class="content">
      <div class="extraPageContainer">
        <iframe class="extraPage" :src="pageURL" frameborder="0"></iframe>
      </div>

    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config';
  import {mapState} from 'vuex';

  export default {
    name: "notice",
    data() {
      return {
        // pageURL:null,
        // modalTitle:null,
        width:'80%',
        maxWidth:1540,
        height:'80%',
        maxHeight:885
      }
    },
    props:{
      modalTitle:{
        type:String,
      },
      pageURL:{
        type:String,
      },

    },
    methods: {
      close() {
        this.$modal.hide("extraPage");
      },
      beforeOpen(data){
        this.pageURL=data.params.url;
        this.modalTitle=data.params.title;
        if(data.params.setModalSize){
          this.width=data.params.width;
          this.height=data.params.height;
          this.maxWidth=999999;
          this.maxHeight=999999;
        }
      }
    },
    computed: {},
    mounted() {},
    filters:{},
    components: {}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .extraPageComp
    width 100%
    height 100%
    background-color #ffffff
  .content
    .extraPageContainer
      width 100%
      height 100%
      .extraPage
        width 100%
        height 100%
</style>


// WEBPACK FOOTER //
// src/components/globalComp/extraPageComp.vue